export const experiences = [
  // {
  //   "from": "August 2025",
  //   "to": "Present",
  //   "role": "SSE",
  //   "company": "BrowserStack",
  //   "url": "https://www.browserstack.com/",
  //   "description": ""
  // },
  {
    "from": "November 2022",
    "to": "April 2025",
    "role": "SDE-2",
    "company": "Nova Benefits",
    "url": "https://www.novabenefits.com/",
    "description": "Built notification engine from scratch; scaled capacity 6x monthly to support 10x increase in client base and associated notifications. Integrated 3rd-party insurance APIs, reducing claim processing times by 30 minutes per claim for 10 claims associates."
  },
  {
    "from": "November 2020",
    "to": "November 2022",
    "role": "SDE-1",
    "company": "Nova Benefits",
    "url": "https://www.novabenefits.com/",
    "description": "I work on Frontend as well as on Backend. With Vue2 in the Frontend and communicating with GraphQL API with Postgres, Typescript in the Backend worked on various interfaces and integrations. Also helped the company in adding RASA as the NLU Layer in one of the internal applications."
  },
  {
    "from": "January 2020",
    "to": "April 2020",
    "role": "SDE Intern",
    "company": "TapChief",
    "url": "https://www.tapchief.com/",
    "description": "For the major part of the internship, I worked on building the onboarding flow for businesses and consultants (i.e. users). Also helped the company to deploy it on Heroku."
  },
  // {
  //   "from": "June 2019",
  //   "to": "July 2019",
  //   "role": "SDE Intern",
  //   "company": "Winimy AI",
  //   "url": "https://www.winimy.ai/",
  //   "description": "I worked on developing voice applications on Amazon Alexa for Dominos. I also developed the Hindi Alexa skill for Isha Sadhguru."
  // },
  // {
  //   "from": "January 2019",
  //   "to": "January 2019",
  //   "role": "Backend Developer Intern",
  //   "company": "Expresso Labs",
  //   "url": "https://www.espressolabs.in/",
  //   "description": "Explored JOVO Framework for cross-platform development of voice application. I also developed a grocery store voice application on Amazon Alexa."
  // }
];